<div class="page" *ngIf="pageModel">

    <p class="multi-response-page-hint" *ngIf="pageModel?.fieldValues?.['IsMultiResponsePage']">
        Multi Response Page
    </p>

    <div class="page-navigation">
        <div class="page-hint">Page {{pageModel.order + 1}} of {{ totalPage }}</div>
        <ul class="buttons">
            <li><i class="fa-regular fa-chevron-up" (click)="upSection()"></i></li>
            <li><i class="fa-regular fa-chevron-down" (click)="downSection()"></i></li>
            <li>
                <!--        <i class="fa-solid fa-ellipsis" (click)="addField()"></i>-->
                <button mat-icon-button [matMenuTriggerFor]="actionMenu">
                    <i class="fa-regular fa-ellipsis"></i>
                </button>
                <mat-menu #actionMenu="matMenu" class="activity-menu" [overlapTrigger]="false">
                    <!-- <button mat-menu-item class="" (click)="addGroup();">
                      <span>Add Group</span>
                    </button> -->
                    <button mat-menu-item class="" (click)="renamePage();">
                        <span>Edit Page</span>
                    </button>
                    <button mat-menu-item class="" (click)="deletePage();">
                        <span>Delete Page</span>
                    </button>
                </mat-menu>
            </li>
            <!-- <li><i class="fa-regular fa-xmark" (click)="deletePage()"></i></li> -->
        </ul>
    </div>
    <div class="page-header">
        <div class="content">{{pageModel.title}}</div>
    </div>

    <elite-form-field-designer-canvas [pageModel]="pageModel" [questions]="questions"
        [flowchartSection]="flowchartSection">
    </elite-form-field-designer-canvas>
</div>